import {
	useEffect,
	useRef,
} from 'react';

export enum Interval {
  SECOND = 1000,
  MINUTE = 60 * 1000,
  HOUR = 60 * 60 * 1000
}

/**
 * Runs an interval, that triggers a callback.
 * Source: https://usehooks-typescript.com/react-hook/use-interval
 * @param callback {() => void} The callback you wish to trigger on an interval.
 * @param delay {number} - The delay. Give it a numberical value or null to stop it.
 */
export const useInterval = (callback: () => void, delay: number | null): void => {
	const savedCallback = useRef(callback);

	// Remember the latest callback if it changes.
	useEffect(() => {
		savedCallback.current = callback;
	}, [callback]);

	// Set up the interval.
	useEffect(() => {
		// Don't schedule if no delay is specified.
		if (delay === null) {
			return;
		}

		const id = setInterval(() => savedCallback.current(), delay);

		// eslint-disable-next-line consistent-return
		return () => clearInterval(id);
	}, [delay]);
};